import { useSelector } from 'react-redux';

import * as store from '../../state/store';

const useLoggedInUserId = (): string | null =>
  useSelector<store.IAppState, string | null>(state => state.loggedInUserId);

export default useLoggedInUserId;
